import * as types from 'constants/action_types'

export function doShowSnackbar(
  message,
  { duration = 3000, link, linkText } = {}
) {
  return {
    type: types.SHOW_SNACKBAR,
    data: {
      id: Date.now(),
      message,
      duration,
      link,
      linkText,
    },
  }
}

export function doHideSnackbar() {
  return {
    type: types.HIDE_SNACKBAR,
  }
}
